import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'
import kubun from 'config/kubun.json'

export const LevelKbn = props => {
  const options = kubun.level_kbn
  return <Dropdown.Standard options={options} {...props} />
}
